"use strict";

var _interopRequireDefault = require("/mnt/www/planning-web-v2/node_modules/@babel/runtime/helpers/interopRequireDefault.js");

require("core-js/modules/es7.object.get-own-property-descriptors");

require("core-js/modules/es6.object.keys");

require("core-js/modules/es6.reflect.construct");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("core-js/modules/es7.array.includes");

require("core-js/modules/es6.string.includes");

require("core-js/modules/es6.string.iterator");

require("core-js/modules/es6.set");

require("core-js/modules/es6.number.constructor");

require("core-js/modules/es6.regexp.to-string");

require("core-js/modules/es6.regexp.split");

require("core-js/modules/es6.array.find");

require("core-js/modules/web.dom.iterable");

var _toConsumableArray2 = _interopRequireDefault(require("/mnt/www/planning-web-v2/node_modules/@babel/runtime-corejs2/helpers/toConsumableArray.js"));

var _defineProperty2 = _interopRequireDefault(require("/mnt/www/planning-web-v2/node_modules/@babel/runtime-corejs2/helpers/defineProperty.js"));

require("core-js/modules/es6.function.name");

require("regenerator-runtime/runtime");

var _asyncToGenerator2 = _interopRequireDefault(require("/mnt/www/planning-web-v2/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator.js"));

var _classCallCheck2 = _interopRequireDefault(require("/mnt/www/planning-web-v2/node_modules/@babel/runtime-corejs2/helpers/classCallCheck.js"));

var _createClass2 = _interopRequireDefault(require("/mnt/www/planning-web-v2/node_modules/@babel/runtime-corejs2/helpers/createClass.js"));

var _inherits2 = _interopRequireDefault(require("/mnt/www/planning-web-v2/node_modules/@babel/runtime-corejs2/helpers/inherits.js"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("/mnt/www/planning-web-v2/node_modules/@babel/runtime-corejs2/helpers/possibleConstructorReturn.js"));

var _getPrototypeOf2 = _interopRequireDefault(require("/mnt/www/planning-web-v2/node_modules/@babel/runtime-corejs2/helpers/getPrototypeOf.js"));

var _tslib = require("tslib");

var _vuePropertyDecorator = require("vue-property-decorator");

var _vuexClass = require("vuex-class");

var _socket = require("socket.io-client");

var _elementUi = require("element-ui");

var _loading = require("@/mixins/loading/loading");

var _lastMileV = require("@/mixins/last-mile-v2/last-mile-v2");

var _permission = require("@/mixins/permission/permission");

var _idle = require("@/mixins/idle/idle");

var _autoLogout = require("@/mixins/auto-logout/auto-logout");

var _orderDateRange = _interopRequireDefault(require("../components/order-date-range/order-date-range.vue"));

var _orderFilter = _interopRequireDefault(require("../components/order-filter/order-filter.vue"));

var _orderFilterTag = _interopRequireDefault(require("../components/order-filter-tag/order-filter-tag.vue"));

var _orderTable = _interopRequireDefault(require("../components/order-table/order-table.vue"));

var _ganttFilter = _interopRequireDefault(require("../components/gantt-filter/gantt-filter.vue"));

var _ganttPagination = _interopRequireDefault(require("../components/gantt-pagination/gantt-pagination.vue"));

var _ganttChart = _interopRequireDefault(require("../components/gantt-chart/gantt-chart.vue"));

var _planHeader = _interopRequireDefault(require("../components/plan-header/plan-header.vue"));

var _planSearch = _interopRequireDefault(require("../components/plan-search/plan-search.vue"));

var _orderSummary = _interopRequireDefault(require("../components/order-summary/order-summary.vue"));

var _truckSummary = _interopRequireDefault(require("../components/truck-summary/truck-summary.vue"));

var _variables = _interopRequireDefault(require("@/styles/mixins/_variables.scss"));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var LMDManualAssignComponent = /*#__PURE__*/function (_Mixins) {
  (0, _inherits2.default)(LMDManualAssignComponent, _Mixins);

  var _super = _createSuper(LMDManualAssignComponent);

  function LMDManualAssignComponent() {
    var _this;

    (0, _classCallCheck2.default)(this, LMDManualAssignComponent);
    _this = _super.apply(this, arguments);
    _this.isShowFailedOrders = false;
    _this.failedOrders = [];
    _this.selectedPlanId = null;
    _this.initAutoAddedDays = 0;
    _this.timeStepper = 30;
    _this.truckCurrentPage = 1;
    _this.truckPageSize = 20;
    _this.socket = null;
    _this.isBlocked = false;
    _this.autoAssignUsername = null;
    _this.globalUsers = [];
    _this.isFilterTruck = false;
    _this.isShowEnabledTruck = false;
    _this.isUpdateBufferTrucks = {
      hasValue: false
    };
    _this.isShowUploadCSV = false;
    _this.dataSet = null;
    return _this;
  }

  (0, _createClass2.default)(LMDManualAssignComponent, [{
    key: "$isOrderFullscreen",
    get: function get() {
      return this.$store.getters['common/isOrderFullscreen'];
    }
  }, {
    key: "planHeaderStyle",
    get: function get() {
      return {
        top: !this.$isFullscreen ? '60px' : 0
      };
    }
  }, {
    key: "planBodyStyle",
    get: function get() {
      var height = '47px';

      if (this.$isFullscreen && !this.$isOrderFullscreen) {
        height = '44px';
      }

      if (this.$isFullscreen && this.$isOrderFullscreen) {
        height = '0';
      }

      return {
        'margin-top': height
      };
    }
  }, {
    key: "beforeRouteLeave",
    value: function beforeRouteLeave(to, from, next) {
      this.confirmUnsavedChanges(to, from, next);
    }
  }, {
    key: "created",
    value: function created() {
      if (window.innerWidth < _variables.default['md-min']) {
        this.$isMobile = true;
      }
    }
  }, {
    key: "mounted",
    value: function () {
      var _mounted = (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var _query;

        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                this.routes = [];
                this.$setTableLoading(true);
                _context.next = 4;
                return this.$getOrderLocationLists({
                  locationType: this.$defaultLocationType,
                  startTime: this.$startDate,
                  endTime: this.$endDate
                });

              case 4:
                _context.next = 6;
                return this.$getTrucks(true);

              case 6:
                _context.next = 8;
                return this.$initPlan();

              case 8:
                _context.next = 10;
                return this.$getUnassignedOrders();

              case 10:
                this.socket = (0, _socket.io)("".concat(process.env.VUE_APP_API_ROUTING_SOCKET, "/v1/lastmile/planning"), {
                  secure: true,
                  reconnection: true,
                  rejectUnauthorized: false,
                  query: (_query = {}, (0, _defineProperty2.default)(_query, process.env.VUE_APP_CUSTOMER_KEY, this.$userInformation.customerKey), (0, _defineProperty2.default)(_query, "routeName", this.$route.name), (0, _defineProperty2.default)(_query, "userEmail", this.$userInformation.user.name), _query),
                  extraHeaders: (0, _defineProperty2.default)({}, process.env.VUE_APP_SECRET_KEY, process.env.VUE_APP_SECRET_KEY_HASH)
                });
                this.updateSelectedData();

              case 12:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function mounted() {
        return _mounted.apply(this, arguments);
      }

      return mounted;
    }()
  }, {
    key: "beforeDestroy",
    value: function beforeDestroy() {
      this.routes = [];

      if (this.socket) {
        this.socket.close();
      }
    }
  }, {
    key: "handleManualAssign",
    value: function () {
      var _handleManualAssign = (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(planId) {
        var truckObj;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                truckObj = this.getTruckInPlan(this.$selectedTruck);

                if (truckObj) {
                  _context2.next = 6;
                  break;
                }

                _context2.next = 4;
                return this.manualAssignTruck('INIT', null, planId);

              case 4:
                _context2.next = 8;
                break;

              case 6:
                _context2.next = 8;
                return this.manualAssignTruck('UPDATE', truckObj, planId);

              case 8:
                _context2.next = 10;
                return this.savePlan(this.$plan);

              case 10:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function handleManualAssign(_x) {
        return _handleManualAssign.apply(this, arguments);
      }

      return handleManualAssign;
    }()
  }, {
    key: "manualAssignTruck",
    value: function () {
      var _manualAssignTruck = (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(type, truckObj, planId) {
        var _this2 = this;

        var bufferSelectedOrders, isNewPlanId, newPlanId, res, customId, prefix, newPlanIds, hasCompletedWaypoint, hasLocked, hasAssignComplete, isAssignDriver, payload, isAssignSuccessful, assignDriverResponse, invalidOrders, message;
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                this.isManualAssignLoading = true;
                bufferSelectedOrders = (0, _toConsumableArray2.default)(this.$selectedOrders);
                isNewPlanId = planId === 'newPlanId';
                newPlanId = planId;
                res = null;

                if (!isNewPlanId) {
                  _context3.next = 16;
                  break;
                }

                // WARNING: HARD CODED LOGIC FOR PNS
                customId = this.helper.PNSCustomId(this.$userInformation, this.$selectedOrders); // WARNING: HARD CODED LOGIC FOR PNS

                prefix = this.helper.generateNewPlanId(this.$userData.planIdFormat, this.$planDate, this.$userInformation, 'lastmile', customId);
                _context3.next = 10;
                return this.routeAPI.generateLoadPlanId(prefix, 1);

              case 10:
                newPlanIds = _context3.sent;
                newPlanId = this.helper.get(newPlanIds, 'data.0', '');

                if (!this.helper.isEmpty(newPlanId)) {
                  _context3.next = 16;
                  break;
                }

                _elementUi.Notification.error({
                  title: this.$t('general.planNumberFailed'),
                  duration: 5000
                });

                this.isManualAssignLoading = false;
                return _context3.abrupt("return", false);

              case 16:
                hasCompletedWaypoint = false;
                this.helper.forEach(this.$selectedOrders, function (order) {
                  if (_this2.helper.some(order['waypoints'], function (i) {
                    return i['completedTime'] !== '0000-00-00 00:00:00' && i['completedTime'] !== null;
                  })) {
                    hasCompletedWaypoint = true;
                    return false;
                  }
                });

                if (!(type === 'INIT')) {
                  _context3.next = 28;
                  break;
                }

                if (!hasCompletedWaypoint) {
                  _context3.next = 25;
                  break;
                }

                _context3.next = 22;
                return this.handleAdhocV2NewTruckObj({
                  planId: newPlanId
                });

              case 22:
                res = _context3.sent;
                _context3.next = 28;
                break;

              case 25:
                _context3.next = 27;
                return this.handleNewTruckObj({
                  planId: newPlanId
                });

              case 27:
                res = _context3.sent;

              case 28:
                hasLocked = false;
                hasAssignComplete = false;

                if (!(type === 'UPDATE')) {
                  _context3.next = 41;
                  break;
                }

                if (truckObj['routes'] && truckObj['routes'].length >= 1) {
                  hasLocked = !!truckObj['routes'].find(function (tData) {
                    return tData['locked'] === true;
                  });
                  hasAssignComplete = truckObj['routes'].find(function (tData) {
                    return (// tData['status'].toUpperCase() === 'ASSIGNED' ||
                      tData['status'].toUpperCase() === 'INTRANSIT' || tData['status'].toUpperCase() === 'COMPLETED'
                    );
                  });
                }

                if (!((hasLocked || hasAssignComplete || hasCompletedWaypoint) && !isNewPlanId)) {
                  _context3.next = 38;
                  break;
                }

                _context3.next = 35;
                return this.handleAdhocV2ExistingTruckObj({
                  planId: newPlanId,
                  truckObj: truckObj,
                  unassignedOrders: this.$selectedOrders
                });

              case 35:
                res = _context3.sent;
                _context3.next = 41;
                break;

              case 38:
                _context3.next = 40;
                return this.handleExistingTruckObj({
                  planId: newPlanId,
                  isNewPlanId: isNewPlanId,
                  truckObj: truckObj
                });

              case 40:
                res = _context3.sent;

              case 41:
                if (!this.helper.isUndefined(res)) {
                  _context3.next = 44;
                  break;
                }

                this.isManualAssignLoading = false;
                return _context3.abrupt("return");

              case 44:
                this.handleFailedOrders(res);
                isAssignDriver = this.helper.get(res, 'isAssignDriver', false);
                payload = this.helper.get(res, 'assignDriverPayload', []);
                isAssignSuccessful = false;

                if (!(isAssignDriver && payload.length)) {
                  _context3.next = 66;
                  break;
                }

                _context3.next = 51;
                return this.assignDriver(payload);

              case 51:
                assignDriverResponse = _context3.sent;
                isAssignSuccessful = assignDriverResponse['isSuccess'];
                invalidOrders = assignDriverResponse['invalidOrders'];
                message = {
                  title: this.$i18n.t('planning.messages.assignOrderSuccess'),
                  duration: 5000
                };

                if (!isAssignSuccessful) {
                  _context3.next = 62;
                  break;
                }

                _elementUi.Notification.success(message);

                this.$isAssignedDriverChanges = false;
                _context3.next = 60;
                return this.savePlan(this.$plan);

              case 60:
                _context3.next = 64;
                break;

              case 62:
                message['message'] = "".concat(this.$i18n.t('planning.messages.assigningFailedBecause'), " ").concat(invalidOrders, " ").concat(this.$i18n.t('planning.messages.cantBeAssigned'));

                _elementUi.Notification.error(message);

              case 64:
                _context3.next = 67;
                break;

              case 66:
                this.$anyChanges = true;

              case 67:
                // Insert log

                /*this.insertLogs('manual assign', {
                  routeType: 'last-mile-delivery',
                  planDate: this.$planDate,
                       truckId: this.$selectedTruck,
                  truck: this.getTruckInfo(this.$selectedTruck),
                  planId: newPlanId,
                  planDetails: {
                    isInit: type === 'INIT',
                    hasCompletedWaypoint,
                    hasLocked,
                    hasAssignComplete,
                    hasFailedOrders: res['isShowFailedOrders'],
                    isAssignDriver,
                    isAssignSuccessful,
                  },
                  orders: bufferSelectedOrders
                    ? bufferSelectedOrders.map((oData) => ({
                        shipmentReference: oData['shipmentReference'] || '',
                        orderId: oData['id'] || '',
                      }))
                    : [],
                       user: this.$userInformation.user,
                  globalUsers: this.$GLOBAL_ACTIVE_USERS,
                });*/
                this.isManualAssignLoading = false;

              case 68:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function manualAssignTruck(_x2, _x3, _x4) {
        return _manualAssignTruck.apply(this, arguments);
      }

      return manualAssignTruck;
    }()
  }, {
    key: "handleSearchValueIsFound",
    value: function handleSearchValueIsFound(newVal) {
      this.selectedPlanId = newVal;
    }
  }, {
    key: "recalculateTimeList",
    value: function recalculateTimeList(newVal) {
      this.initAutoAddedDays = newVal;
    }
  }, {
    key: "handleTimeStepperChanges",
    value: function handleTimeStepperChanges(newVal) {
      this.timeStepper = newVal;
    }
  }, {
    key: "handleFailedOrders",
    value: function handleFailedOrders(_ref) {
      var isShowFailedOrders = _ref.isShowFailedOrders,
          failedOrders = _ref.failedOrders;
      this.isShowFailedOrders = isShowFailedOrders;
      this.failedOrders = this.helper.orderBy(failedOrders.map(function (fOData) {
        fOData['finalCode'] = fOData['code'] || '';
        fOData['finalPriority'] = '';

        if (fOData['code']) {
          var codeArr = fOData['code'].toString().split('-');

          if (codeArr.length === 2) {
            fOData['finalPriority'] = codeArr[0] || '';
            fOData['finalCode'] = codeArr[1] || '';
          }
        }

        return fOData;
      }), ['finalPriority'], ['asc']);
      this.$failedOrders = failedOrders;
    }
  }, {
    key: "updateSelectedData",
    value: function updateSelectedData() {
      var _this3 = this;

      this.socket.on('connect', /*#__PURE__*/(0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _this3.logger.info('socket-connected', _this3.socket.id);

                _this3.$socketId = _this3.socket.id;
                _this3.isBlocked = false;
                _this3.isOccupied = false;

              case 4:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4);
      })));
      this.socket.on('connected', /*#__PURE__*/function () {
        var _ref3 = (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee5(res) {
          var userData;
          return regeneratorRuntime.wrap(function _callee5$(_context5) {
            while (1) {
              switch (_context5.prev = _context5.next) {
                case 0:
                  userData = _this3.helper.get(res, 'data.userData', []);

                  if (userData && userData.length >= 1) {
                    userData = userData.filter(function (uData) {
                      return Number(uData.companyId) === Number(_this3.$userInformation.company.id);
                    });

                    if (userData[0] && userData[0]['routeName'] !== _this3.$route.name && userData[0]['userId'] !== _this3.$socketId) {
                      _this3.isBlocked = true;
                      _this3.autoAssignUsername = userData[0]['userName'].split('@')[0];
                      _this3.isOccupied = true;
                      _this3.occupyingUsername = userData[0]['userName'].split('@')[0];
                      _this3.occupyingRoute = userData[0]['routeName'];
                    } else {
                      _this3.isBlocked = false;
                      _this3.isOccupied = false;
                    }
                  } else {
                    _this3.isBlocked = false;
                    _this3.isOccupied = false;
                  }

                  _this3.logger.info('Socket - Connected', res);

                  if (res.data && res.status === 'success') {
                    _this3.$GLOBAL_ACTIVE_USERS = (0, _toConsumableArray2.default)(userData);
                    _this3.$GLOBAL_SELECTED_ORDERS = res.data.orderData.length >= 1 ? res.data.orderData.filter(function (oData) {
                      return oData['userId'] !== _this3.$socketId;
                    }) : [];
                    _this3.$GLOBAL_SELECTED_TRUCKS = res.data.truckData.length >= 1 ? res.data.truckData.filter(function (tData) {
                      return tData['userId'] !== _this3.$socketId;
                    }) : [];
                  }

                case 4:
                case "end":
                  return _context5.stop();
              }
            }
          }, _callee5);
        }));

        return function (_x5) {
          return _ref3.apply(this, arguments);
        };
      }());
      this.socket.on('saved', function (res) {
        _this3.logger.info('Socket - Saved', res);

        if (res.status === 'success' && res.data && res.data.code === _this3.$planDate) {
          _this3.updatePlanFromSocket(res.data);
        }
      });
      this.socket.on('error', /*#__PURE__*/function () {
        var _ref4 = (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee6(res) {
          return regeneratorRuntime.wrap(function _callee6$(_context6) {
            while (1) {
              switch (_context6.prev = _context6.next) {
                case 0:
                  _this3.logger.info('socket-error');

                case 1:
                case "end":
                  return _context6.stop();
              }
            }
          }, _callee6);
        }));

        return function (_x6) {
          return _ref4.apply(this, arguments);
        };
      }());
      this.socket.on('connect_error', /*#__PURE__*/function () {
        var _ref5 = (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee7(res) {
          return regeneratorRuntime.wrap(function _callee7$(_context7) {
            while (1) {
              switch (_context7.prev = _context7.next) {
                case 0:
                  _this3.logger.info('socket-connect_error');

                case 1:
                case "end":
                  return _context7.stop();
              }
            }
          }, _callee7);
        }));

        return function (_x7) {
          return _ref5.apply(this, arguments);
        };
      }());
    }
  }, {
    key: "getReasonFailMessage",
    value: function getReasonFailMessage(reason) {
      return this.$t("planning.autoAssignInvalidCodes.".concat(reason));
    }
  }, {
    key: "getReasonFailParam",
    value: function getReasonFailParam() {
      var reason = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      var reasonArr = reason.split('~');
      return this.helper.get(reasonArr, '1', '-').trim();
    }
  }, {
    key: "handleTruckSizeChange",
    value: function handleTruckSizeChange(newVal) {
      this.truckPageSize = newVal;
    }
  }, {
    key: "handleTruckCurrentChange",
    value: function handleTruckCurrentChange(newVal) {
      this.truckCurrentPage = newVal;
    }
  }, {
    key: "handleIsFilterTruckChanges",
    value: function handleIsFilterTruckChanges(newVal) {
      this.isFilterTruck = newVal;
    }
  }, {
    key: "handleIsShowEnabledTruckChanges",
    value: function handleIsShowEnabledTruckChanges(newVal) {
      this.isShowEnabledTruck = newVal;
    }
  }, {
    key: "handleUpdateBufferTrucks",
    value: function handleUpdateBufferTrucks(newVal) {
      this.isUpdateBufferTrucks = newVal;
    }
  }, {
    key: "onDataSetChanges",
    value: function onDataSetChanges() {
      var file = this.$refs.dataSet;

      if (typeof file !== 'undefined') {
        this.dataSet = file.files[0];
      }
    }
  }, {
    key: "handleAssignCSVError",
    value: function handleAssignCSVError() {
      var message = {
        title: this.$i18n.t('planning.messages.noSolution'),
        duration: 5000
      };

      _elementUi.Notification.error(message);

      this.isAutoAssignLoading = false;
      this.isShowUploadCSV = false;
    }
  }, {
    key: "csvAssignToTruck",
    value: function () {
      var _csvAssignToTruck = (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee8() {
        var formData, res, data;
        return regeneratorRuntime.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                this.isAutoAssignLoading = true;

                if (!this.helper.isUndefined(this.dataSet)) {
                  _context8.next = 4;
                  break;
                }

                this.handleAssignCSVError();
                return _context8.abrupt("return");

              case 4:
                formData = new FormData();
                formData.append('userEmail', this.$userInformation.user.name);
                formData.append('dateTime', "".concat(this.$planDate, " ").concat(this.$userSetting.default6));
                formData.append('timeWindow', this.$userSetting.default2);
                formData.append('data', this.dataSet);
                _context8.next = 11;
                return this.lastMileDeliveryAPI.csvAssign(formData, {
                  code: this.$planDate
                });

              case 11:
                res = _context8.sent;
                data = this.helper.get(res, 'data', null);
                _context8.next = 15;
                return this.handleCSVAssign(data);

              case 15:
                this.isShowUploadCSV = false;
                this.isAutoAssignLoading = false;

              case 17:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee8, this);
      }));

      function csvAssignToTruck() {
        return _csvAssignToTruck.apply(this, arguments);
      }

      return csvAssignToTruck;
    }()
  }, {
    key: "handleCSVAssign",
    value: function () {
      var _handleCSVAssign = (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee9(autoAssign) {
        var _this4 = this;

        var orders, trucks, invalidOrderIds, selectedOrderIds, invalidRes, message, failedOrders, _message, finalOrderIds, filteredOutTruckIds, plan, _message2;

        return regeneratorRuntime.wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                orders = this.helper.get(autoAssign, 'orders', []);

                if (orders.length) {
                  _context9.next = 3;
                  break;
                }

                return _context9.abrupt("return");

              case 3:
                trucks = [];
                invalidOrderIds = [];
                selectedOrderIds = [];
                invalidRes = [];

                if (autoAssign['invalid'] && autoAssign['invalid'].length >= 1) {
                  invalidRes = (0, _toConsumableArray2.default)(autoAssign['invalid']);
                }

                this.failedOrders = [];
                this.$failedOrders = [];

                if (autoAssign && invalidRes.length > 0 && autoAssign['vehicles'] && autoAssign['vehicles'].length) {
                  message = {
                    title: this.$i18n.t('planning.messages.successInvalidRoutes'),
                    duration: 5000
                  };

                  _elementUi.Notification.success(message); // NOTE: fix grouping logic is on backend


                  failedOrders = invalidRes.map(function (irData) {
                    selectedOrderIds.push(irData['orderId']);
                    return {
                      code: irData['code'] || '',
                      type: irData['type'] || '',
                      reason: irData['reason'] || '',
                      orderId: irData['orderId'] || [],
                      shipmentReference: irData['shipmentReference'] || [],
                      plateNumber: irData['plateNumber'] || [],
                      vehicleId: irData['vehicleId'] || []
                    };
                  }); // invalidOrderIds = this.helper.flatten(failedOrders.map(i => i.orderId));

                  invalidOrderIds = (0, _toConsumableArray2.default)(autoAssign['invalidOrder']);
                  this.handleFailedOrders({
                    isShowFailedOrders: true,
                    failedOrders: failedOrders
                  });
                  this.$pagination = _objectSpread(_objectSpread({}, this.$pagination), {}, {
                    currentPage: 1
                  });
                  this.logger.info('handleCSVAssign - Set pagination', JSON.stringify(this.$pagination));
                }

                if (!(this.helper.get(autoAssign, 'error', null) === 'no solution found' || this.helper.get(autoAssign, 'error', null) === 'no vehicle found')) {
                  _context9.next = 16;
                  break;
                }

                _message = {
                  title: this.$i18n.t('planning.messages.noSolution'),
                  duration: 5000
                };

                _elementUi.Notification.error(_message);

                _context9.next = 35;
                break;

              case 16:
                if (!(autoAssign && autoAssign['vehicles'] && autoAssign['vehicles'].length)) {
                  _context9.next = 33;
                  break;
                }

                finalOrderIds = [];
                filteredOutTruckIds = [];
                autoAssign['vehicles'].forEach(function (vehicle) {
                  var truckObj = _this4.getTruckInPlan(vehicle.truckId);

                  if (vehicle.orderId && vehicle.orderId.length >= 1) {
                    if (vehicle.type === 'MANUALASSIGN' && !_this4.helper.isUndefined(truckObj)) {
                      finalOrderIds = _this4.helper.uniq([].concat((0, _toConsumableArray2.default)(finalOrderIds), (0, _toConsumableArray2.default)(vehicle.orderId), (0, _toConsumableArray2.default)(truckObj['orderId'])));
                    } else {
                      finalOrderIds = _this4.helper.uniq([].concat((0, _toConsumableArray2.default)(finalOrderIds), (0, _toConsumableArray2.default)(vehicle.orderId)));
                    }
                  }

                  if (vehicle.routes && vehicle.routes.length > 0) {
                    filteredOutTruckIds.push(vehicle.truckId);
                    var nOrderIds = [];
                    vehicle.routes.map(function (route) {
                      nOrderIds = [].concat((0, _toConsumableArray2.default)(nOrderIds), (0, _toConsumableArray2.default)(route['orderId']));
                      return route;
                    });
                    trucks.push(_objectSpread(_objectSpread({}, vehicle), {}, {
                      orderId: (0, _toConsumableArray2.default)(new Set(nOrderIds)),
                      locked: false,
                      hasUpdate: true
                    }));
                  }
                });

                if (trucks.length > 0) {
                  this.$anyChanges = true;
                }

                finalOrderIds = (0, _toConsumableArray2.default)(new Set(finalOrderIds));
                plan = this.helper.cloneDeep(this.$plan);
                plan['orders'] = this.helper.uniqBy([].concat((0, _toConsumableArray2.default)(plan['orders']), (0, _toConsumableArray2.default)(orders)).filter(function (o) {
                  return !invalidOrderIds.includes(o['id']);
                }), 'id');
                plan['trucks'] = this.helper.uniqBy([].concat((0, _toConsumableArray2.default)(plan['trucks'].filter(function (i) {
                  return !_this4.helper.includes(filteredOutTruckIds, i.truckId);
                })), trucks), 'truckId');
                this.$setPlan({
                  plan: plan
                });
                this.$selectedOrders = this.$selectedOrders.filter(function (i) {
                  return _this4.helper.includes(selectedOrderIds, i['id']);
                });
                this.$excludedOrders = this.helper.uniq((0, _toConsumableArray2.default)(this.$plan.orders.map(function (o) {
                  return o['id'];
                })));
                this.logger.info('handleCSVAssign - Get Unassigned Orders');
                _context9.next = 31;
                return this.$getUnassignedOrders();

              case 31:
                _context9.next = 35;
                break;

              case 33:
                _message2 = {
                  title: this.$i18n.t('planning.messages.noTrucks'),
                  duration: 5000
                };

                _elementUi.Notification.error(_message2);

              case 35:
              case "end":
                return _context9.stop();
            }
          }
        }, _callee9, this);
      }));

      function handleCSVAssign(_x8) {
        return _handleCSVAssign.apply(this, arguments);
      }

      return handleCSVAssign;
    }()
  }]);
  return LMDManualAssignComponent;
}((0, _vuePropertyDecorator.Mixins)(_permission.PermissionMixin, _loading.LoadingMixin, _lastMileV.LastMileDeliveryMixin, _idle.IdleMixin, _autoLogout.AutoLogoutMixin));

(0, _tslib.__decorate)([(0, _vuexClass.Getter)('isFullscreen', {
  namespace: 'common'
})], LMDManualAssignComponent.prototype, "$isFullscreen", void 0);
LMDManualAssignComponent = (0, _tslib.__decorate)([(0, _vuePropertyDecorator.Component)({
  name: 'LMDManualAssignComponent',
  components: {
    'order-date-range': _orderDateRange.default,
    'order-filter': _orderFilter.default,
    'order-filter-tag': _orderFilterTag.default,
    'order-table': _orderTable.default,
    'gantt-filter': _ganttFilter.default,
    'gantt-pagination': _ganttPagination.default,
    'gantt-chart': _ganttChart.default,
    'plan-header': _planHeader.default,
    'plan-search': _planSearch.default,
    'order-summary': _orderSummary.default,
    'truck-summary': _truckSummary.default,
    'el-row': _elementUi.Row,
    'el-col': _elementUi.Col,
    'el-dialog': _elementUi.Dialog,
    'el-button': _elementUi.Button
  }
})], LMDManualAssignComponent);
var _default = LMDManualAssignComponent;
exports.default = _default;